import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { AnimationSettingsModel } from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import { BsCheck2 } from 'react-icons/bs';
import { BiX } from 'react-icons/bi';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  addTrainingSettings,
  deleteTrainingSettings,
  editTrainingSettings,
  getTrainingSettings,
} from '../../../services/Position/PositionServices';
interface IProps {}
interface IState {
  TrainingItemsData: Array<any>;
  TrainingCategoriesData: Array<any>;
}
class TrainingItems extends Component<IProps, IState> {
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public validationNumberRule: Object = { required: true, number: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private animationSettings: AnimationSettingsModel;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  private gridTrainingItemsObj: any;
  private dropTrackExpiryObj: any;
  private dropCategoriObj: any;
  private type: string = 'item';
  constructor(props: IProps) {
    super(props);
    this.state = {
      TrainingItemsData: [],
      TrainingCategoriesData: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
  }
  getTrainingItems() {
    getTrainingSettings(this.type).then((res) => {
      let model = res.data.map((items: any) => {
        return {
          ...items,
        };
      });
      this.setState({ TrainingItemsData: model });
    });
  }
  async getTrainingCategories() {
    await getTrainingSettings('categorie').then((res) => {
      this.setState({ TrainingCategoriesData: res.data });
    });
  }
  actionBeginPosition(args: any) {
    if (args.action === 'add') {
      this.savePointAddTrainingItems(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditTrainingItems(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteTrainingItems(args.data);
    }
  }
  async componentDidMount() {
    loadingShow(true);
    setTimeout(() => {
      loadingShow(false);
    }, 10000);
    await this.getTrainingItems();
    await this.getTrainingCategories();
    loadingShow(false);
  }
  savePointAddTrainingItems(obje: any) {
    let training_categori = this.dropCategoriObj.value;
    let is_track_expiry = this.dropTrackExpiryObj.checked;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      training_categori_id: training_categori === null ? -1 : training_categori,
      code: obje.code,
      is_track_expiry: is_track_expiry,
      created_by: all_information.user_id,
      grace_period: obje.grace_period,
      type: this.type,
    });
    //(ob
    addTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingItems();
      })
      .catch((err: any) => {
        Message.error(err);
        loadingShow(false);
      });
  }
  savePointEditTrainingItems(obje: any) {
    let is_track_expiry = this.dropTrackExpiryObj.checked;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      training_categori_id: this.dropCategoriObj.value,
      name: this.dropCategoriObj.text,
      code: obje.code,
      is_track_expiry: is_track_expiry,
      created_by: all_information.user_id,
      ID: obje.ID,
      grace_period: obje.grace_period,
      type: this.type,
    });
    editTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingItems();
      })
      .catch((err: any) => {
        Message.error(err);
        loadingShow(false);
      });
  }
  savePointDeleteTrainingItems(obje: any) {
    const obj = JSON.stringify({
      ID: obje[0].ID,
    });
    deleteTrainingSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getTrainingItems();
      })
      .catch((err: any) => {
        Message.error(err);
        loadingShow(false);
      });
  }
  private toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getTrainingItems();
    }
    if (
      this.gridTrainingItemsObj &&
      args.item.id === 'gridTrainingItems_excelexport'
    ) {
      this.gridTrainingItemsObj.excelExport();
    }
  }
  trainingCategoriesTemplate = (args: any) => {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.dropCategoriObj = el;
        }}
        placeholder='Training Categories'
        //  onFocus={this.onFocusCategories.bind(this)}
        text={args.training_categori_name}
        value={args.training_categori_id}
        style={{ height: 25 }}
        // dataBound={this.categoriesDataBound.bind(this)}
        dataSource={this.state.TrainingCategoriesData}
        fields={{
          text: 'name',
          value: 'ID',
        }}
      />
    );
  };
  private isTrackExpiryTemplate(args: any) {
    let is_track_expiry = args.is_track_expiry;
    //(is_track_expiry);

    return (
      <div>
        {is_track_expiry ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isTrackExpiryTemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.is_track_expiry}
        ref={(scope) => (this.dropTrackExpiryObj = scope)}
      />
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridTrainingItems'
          dataSource={this.state.TrainingItemsData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridTrainingItemsObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          allowExcelExport={true}
          showColumnChooser
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          // enablePersistence
          allowResizing={true}
          allowGrouping={true}
          style={{ display: 'inline-block' }}
          gridLines='Both'
          height='calc(-220px + 100vh)'
          actionBegin={this.actionBeginPosition.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='name'
              editTemplate={this.trainingCategoriesTemplate.bind(this)}
              headerText='Categori Name'
            />
            <ColumnDirective
              field='code'
              validationRules={this.validationRule}
              headerText='Code'
            />
            <ColumnDirective
              field='grace_period'
              editType='numeric'
              headerText='Grace Period'
            />
            <ColumnDirective
              field='is_track_expiry'
              headerText='Track Expiry'
              width={70}
              template={this.isTrackExpiryTemplate.bind(this)}
              editTemplate={this.isTrackExpiryTemplateEditing.bind(this)}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Group,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}
export default TrainingItems;
